module.exports = __webpack_public_path__ + "media/alter_no_barcode.d2fa2a14.mp3";